import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import ControlledTextField from "../../../components/ControlledTextField";
import { Form } from "react-bootstrap";
import { CardText, CardTitle, Col, Row } from "reactstrap";
import { toast } from "react-toastify";
import image from "../../../assets/images/Image2.PNG";
import logo from "../../../assets/images/logo.PNG";
import ButtonComponent from "../../../components/ButtonComponent";
import "firebase/auth";
import { userLogginData } from "../../../dummyData/userLogginData";
type FormData = {
  userName: string;
  password: string;
};

const SignIn = () => {
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm<FormData>({
    defaultValues: {
      userName: "",
      password: "",
    },
  });

  const handleSignIn = async (data: FormData) => {
    try {
      const user = userLogginData.find(
        (user) =>
          user.userName === data.userName && user.password === data.password
      );
      if (user) {
        toast.success("Welcome Back! You've Logged In Successfully....!");
        localStorage.setItem("userName", user.userName);
        localStorage.setItem("Email", user.email);
        navigate("/dashboard");
      } else {
        toast.error("Invalid username or password.");
      }
    } catch (error: any) {
      toast.error("Something went wrong. Please try again.");
    }
  };
  const onSubmit = (data: FormData) => {
    handleSignIn(data);
  };

  return (
    <div className="signUpBackground">
      <div className="auth-wrapper auth-cover">
        <Row className="auth-inner m-1">
          <Col
            className="d-none d-lg-flex align-items-center p-5"
            lg="5"
            sm="12"
          >
            <div className="w-100 d-lg-flex align-items-center justify-content-center">
              <img className="img-fluid" src={image} alt="Login Cover" />
            </div>
          </Col>
          <Col
            className="d-flex align-items-center auth-bg px-2 p-lg-4"
            lg="7"
            sm="12"
          >
            <Col className="px-xl-2 mx-auto" sm="8" md="6" lg="12">
              <div className="imageAreaBackgroundColor">
                <img
                  className="mb-2"
                  src={logo}
                  alt="loginimage"
                  style={{ width: "100%" }}
                />
              </div>
              <CardTitle tag="h2" className="fw-bold mb-1">
                Welcome to Curry King Task Manager Application! 👋
              </CardTitle>
              <CardText className="mb-2">
                Please sign-In to your account and start the adventure
              </CardText>
              <Form
                className="auth-login-form mt-2"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="mb-1">
                  <ControlledTextField
                    label={"User Name"}
                    inputName={"userName"}
                    inputType={"text"}
                    placeholder={"Enter Your User Name"}
                    isRequired={true}
                    control={control}
                  />
                </div>
                <div className="mb-1">
                  <ControlledTextField
                    label={"Password"}
                    inputName={"password"}
                    isRequired={true}
                    placeholder={"Enter Password"}
                    inputType={"password"}
                    control={control}
                    rules={{ required: true }}
                  />
                </div>
                <Row className="d-flex align-items-center justify-content-left">
                  <Col lg="2">
                    <ButtonComponent title={"Sign In"} type={"submit"} /></Col>
                  <Col lg="2">
                    <Link to="/sign-up">
                      <ButtonComponent title="Sign Up?" />
                    </Link>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SignIn;
